<section class="flex min-h-[calc(100vh-5rem)] items-center justify-center px-gutter py-12">
  <div class="sx-card w-full max-w-md">
    <h1 class="font-display text-2xl font-extrabold text-primary">Admin Login</h1>
    <p class="mt-2 text-sm text-on-surface-variant">Sign in to access CSR web admin endpoints.</p>
    <form class="mt-8 space-y-4" [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <label class="sx-label" for="email">Email</label>
        <input id="email" class="sx-input" type="email" formControlName="email" />
      </div>
      <div>
        <label class="sx-label" for="password">Password</label>
        <input id="password" class="sx-input" type="password" formControlName="password" />
      </div>
      @if (errorMessage) {
        <p class="text-sm font-medium text-error">{{ errorMessage }}</p>
      }
      <button type="submit" class="sx-btn-primary w-full" [disabled]="form.invalid || submitting">
        {{ submitting ? 'Signing In...' : 'Sign In' }}
      </button>
    </form>
    <div class="mt-6 flex flex-wrap gap-4 text-sm font-semibold">
      <a routerLink="/forgot-password" class="text-secondary hover:text-primary">Forgot password?</a>
      <a routerLink="/reset-password" class="text-secondary hover:text-primary">Reset password</a>
      <a routerLink="/partner/login" class="text-secondary hover:text-primary">Partner Login</a>
      <a routerLink="/learner/login" class="text-on-surface-variant hover:text-primary">Back to home</a>
    </div>
  </div>
</section>
